__turbopack_context__.v({
  "active": "ContentHubHero-module-scss-module__v3abdW__active",
  "nav": "ContentHubHero-module-scss-module__v3abdW__nav",
  "navItem": "ContentHubHero-module-scss-module__v3abdW__navItem",
  "navLink": "ContentHubHero-module-scss-module__v3abdW__navLink",
  "navTrack": "ContentHubHero-module-scss-module__v3abdW__navTrack",
  "root": "ContentHubHero-module-scss-module__v3abdW__root",
  "title": "ContentHubHero-module-scss-module__v3abdW__title",
});
